import React from 'react'
import { ButtonsContainer } from '../../styles/button'
import FeaturedButton from './Button'

const Button = props =>
  <FeaturedButton
    icon={props.isIcon && require(`../../assets/icons/${props.text}.svg`)}
    {...props}
  />

export default ({ leftButton, rightButton }) => {
  return (
    <ButtonsContainer>
      <Button {...rightButton} />
      <Button {...leftButton} />
    </ButtonsContainer>
  )
}

